"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var w = Object.create;
var c = Object.defineProperty;
var E = Object.getOwnPropertyDescriptor;
var _ = Object.getOwnPropertyNames,
    f = Object.getOwnPropertySymbols,
    D = Object.getPrototypeOf,
    d = Object.prototype.hasOwnProperty,
    h = Object.prototype.propertyIsEnumerable;

var i = function i(e, t, r) {
  return t in e ? c(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    m = function m(e, t) {
  for (var r in t || (t = {})) {
    d.call(t, r) && i(e, r, t[r]);
  }

  if (f) {
    var _iterator = _createForOfIteratorHelper(f(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        h.call(t, r) && i(e, r, t[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

var R = function R(e, t) {
  var r = {};

  for (var o in e) {
    d.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  }

  if (e != null && f) {
    var _iterator2 = _createForOfIteratorHelper(f(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var o = _step2.value;
        t.indexOf(o) < 0 && h.call(e, o) && (r[o] = e[o]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
};

var v = function v(e, t) {
  for (var r in t) {
    c(e, r, {
      get: t[r],
      enumerable: !0
    });
  }
},
    P = function P(e, t, r, o) {
  if (t && _typeof(t) == "object" || typeof t == "function") {
    var _iterator3 = _createForOfIteratorHelper(_(t)),
        _step3;

    try {
      var _loop = function _loop() {
        var a = _step3.value;
        !d.call(e, a) && a !== r && c(e, a, {
          get: function get() {
            return t[a];
          },
          enumerable: !(o = E(t, a)) || o.enumerable
        });
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return e;
};

var M = function M(e, t, r) {
  return r = e != null ? w(D(e)) : {}, P(t || !e || !e.__esModule ? c(r, "default", {
    value: e,
    enumerable: !0
  }) : r, e);
},
    N = function N(e) {
  return P(c({}, "__esModule", {
    value: !0
  }), e);
};

var j = {};
v(j, {
  Portal: function Portal() {
    return b;
  }
});
module.exports = N(j);

var n = M(require("react")),
    s = require("@reach/utils"),
    y = require("react-dom"),
    g = function g(_ref) {
  var e = _ref.children,
      _ref$type = _ref.type,
      t = _ref$type === void 0 ? "reach-portal" : _ref$type,
      r = _ref.containerRef;
  var o = n.useRef(null),
      a = n.useRef(null),
      l = (0, s.useForceUpdate)();
  return (0, s.useIsomorphicLayoutEffect)(function () {
    if (!o.current) return;
    var u = o.current.ownerDocument,
        p = (r == null ? void 0 : r.current) || u.body;
    return a.current = u == null ? void 0 : u.createElement(t), p.appendChild(a.current), l(), function () {
      a.current && p && p.removeChild(a.current);
    };
  }, [t, l, r]), a.current ? (0, y.createPortal)(e, a.current) : n.createElement("span", {
    ref: o
  });
},
    b = function b(r) {
  var o = r,
      e = o.unstable_skipInitialRender,
      t = R(o, ["unstable_skipInitialRender"]);

  var _n$useState = n.useState(!1),
      _n$useState2 = _slicedToArray(_n$useState, 2),
      a = _n$useState2[0],
      l = _n$useState2[1];

  return n.useEffect(function () {
    e && l(!0);
  }, [e]), e && !a ? null : n.createElement(g, m({}, t));
};

b.displayName = "Portal";
0 && (module.exports = {
  Portal: Portal
});